var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PriceAnalyzeService from '../../api/PriceAnalyzeService';
import moment from 'moment';
import GlobalVue from '../../globalVue';
import Header from './components/Header.vue';
import TableList from '../../components/common/TableList.vue';
import Detail from './Detail.vue';
var PriceAnalyze = (function (_super) {
    __extends(PriceAnalyze, _super);
    function PriceAnalyze() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = PriceAnalyzeService.getInstance();
        _this.fetchAction = _this.service.getList;
        _this.filter = {
            dimension: 1,
            type: 1,
            s_time: moment().subtract(6, 'days').format('YYYY-MM-DD'),
            e_time: moment().format('YYYY-MM-DD'),
            keyword: '',
        };
        _this.cols = [];
        _this.dataActions = [];
        return _this;
    }
    PriceAnalyze.prototype.created = function () {
        this.dataActions = [
            {
                name: '查看趋势图',
                click: this.toDetail,
            },
        ];
        this.initCols();
    };
    PriceAnalyze.prototype.initCols = function () {
        this.cols = [
            {
                key: 'goods_code',
                name: '货品编码',
            },
            {
                key: 'goods_name',
                name: '货品名称',
            },
            {
                key: 'goods_format_name',
                name: '货品规格',
            },
            {
                key: 'supplier_upper_name',
                name: '供应商名称',
                is_hidden: this.filter.type !== 2,
            },
            {
                key: 'supplier_upper_count',
                name: '供应商数量',
                is_hidden: this.filter.type !== 3,
            },
            {
                key: 'order_detail_money',
                name: '入库金额',
                is_hidden: this.filter.dimension === 1,
            },
            {
                key: 'order_detail_uprice',
                name: '入库平均价',
                is_hidden: this.filter.dimension === 2,
            },
            {
                key: 'start_date',
                name: '开始日期',
            },
            {
                key: 'end_date',
                name: '结束日期',
            },
        ];
    };
    PriceAnalyze.prototype.toDetail = function (row) {
        var filter = __assign({}, this.filter, { goods_format_id: row.goods_format_id });
        if (this.filter.type === 2) {
            filter.supplier_upper_id = row.supplier_upper_id;
        }
        this.addTab({
            component: Detail,
            title: '采购价格分析',
            showExist: true,
            name: 'priceAnalyze_' + row.goods_format_id + Math.random(),
            cprops: {
                filter: filter,
                goods_name: row.goods_name,
                supplier_upper_name: row.supplier_upper_name,
            },
        });
        window._czc.push(['_trackEvent', '采购价格分析', '详情']);
    };
    PriceAnalyze.prototype.search = function (filter) {
        var _this = this;
        this.filter = filter;
        this.initCols();
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    PriceAnalyze.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PriceAnalyze = __decorate([
        Component({
            components: {
                'list-header': Header,
                TableList: TableList,
            },
        })
    ], PriceAnalyze);
    return PriceAnalyze;
}(Vue));
export default PriceAnalyze;
